module.exports = __webpack_public_path__ + "static/media/447852618_2002439170151891_1078909091061922144_n.fe9e57fe.jpg";